import { all, takeEvery, put } from 'redux-saga/effects';
import siteConfig from '@iso/config/site.config';
import actions from './actions';
import opsActions from '../ops/actions';
import { notification } from '@iso/components';
const { SET_OPERARIO } = opsActions;

const gaxios = require('gaxios');
gaxios.instance.defaults = {
    baseURL: siteConfig.siteUrl.API_URL
}

export function* getUsers(action) {
    let params = new URLSearchParams(action.query);
    const res = yield gaxios.request({
        url: `api/users-rrhh${action.query ? '?'+ action.query : ""}`,
        headers: {
            Authorization: localStorage.getItem('access_token'),
            AuthId: localStorage.getItem('id_token')
        }
    });
    if (!res.data.success) {
        notification('error', res.data.msg);
    } else {
        action.query ? 
        yield put({
            type: actions.GET_USERS_SUCCESS_QUERY,
            payload: res.data.users,
        }) : yield put({
            type: actions.GET_USERS_SUCCESS,
            payload: res.data.users,
        })
        if(params.get('usuario')){
            yield put({
                type: SET_OPERARIO,
                payload: res.data.users[0]?._id,
            });
        }
        

    }
}
export function* createUser({ payload }) {
    const res = yield gaxios.request({
        url: 'api/users-rrhh',
        method: 'POST',
        data: payload,
        headers: {
            Authorization: localStorage.getItem('access_token'),
            AuthId: localStorage.getItem('id_token')
        }
    });
    if (!res.data.success) {
        notification('error', res.data.msg);
    } else {
        notification('success', res.data.msg);
        yield put({ type: actions.CREATE_USER_SUCCESS, payload: res.data.user });
    }
}
export function* editUser({ payload }) {
    const res = yield gaxios.request({
        url: 'api/users-rrhh/' + payload._id,
        method: 'PUT',
        data: payload,
        headers: {
            Authorization: localStorage.getItem('access_token'),
            AuthId: localStorage.getItem('id_token')
        }
    });
    if (!res.data.success) {
        notification('error', res.data.msg);
    } else {
        notification('success', res.data.msg);
        yield put({ type: actions.GET_USERS_REQUEST });
        yield put({ type: actions.EDIT_USER_SUCCESS, payload: res.data.user });
    }
}
export function* deleteUser({ payload }) {
    const res = yield gaxios.request({
        url: 'api/users-rrhh/' + payload,
        method: 'DELETE',
        headers: {
            Authorization: localStorage.getItem('access_token'),
            AuthId: localStorage.getItem('id_token')
        }
    });
    if (!res.data.success) {
        notification('error', res.data.msg);
    } else {
        notification('success', res.data.msg);
        yield put({ type: actions.DELETE_USER_SUCCESS, payload });
    }
}

export function* fetchNovedades({ payload }) {
    const { empleadoId, mes, anio } = payload;
    const params = new URLSearchParams({ empleado: empleadoId, 'periodo.mes': mes, 'periodo.anio': anio });
    const res = yield gaxios.request({
        url: `api/nomina/novedades?${params}`,
        headers: {
            Authorization: localStorage.getItem('access_token'),
            AuthId: localStorage.getItem('id_token'),
        },
    });
    if (!res.data.success) {
        notification('error', res.data.msg);
    } else {
        yield put({ type: actions.FETCH_NOVEDADES_SUCCESS, payload: res.data.novedades });
    }
}

export function* registrarNovedad({ payload }) {
    const res = yield gaxios.request({
        url: 'api/nomina/novedades',
        method: 'POST',
        data: payload,
        headers: {
            Authorization: localStorage.getItem('access_token'),
            AuthId: localStorage.getItem('id_token'),
        },
    });
    if (!res.data.success) {
        notification('error', res.data.msg);
    } else {
        notification('success', res.data.msg);
        yield put({ type: actions.REGISTRAR_NOVEDAD_SUCCESS, payload: res.data.novedad });
    }
}

export default function* rootSaga() {
    yield all([
        yield takeEvery(actions.GET_USERS_REQUEST, getUsers),
        yield takeEvery(actions.CREATE_USER_REQUEST, createUser),
        yield takeEvery(actions.EDIT_USER_REQUEST, editUser),
        yield takeEvery(actions.DELETE_USER_REQUEST, deleteUser),
        yield takeEvery(actions.FETCH_NOVEDADES_REQUEST, fetchNovedades),
        yield takeEvery(actions.REGISTRAR_NOVEDAD_REQUEST, registrarNovedad),
    ]);
}
